import React from 'react';
import {view, Link} from '@sail/ui';
import {useIntl} from '@sail/intl';
import type {OpenapiAccountTypeEnum} from '@stripe-internal/data-v1/schema/types';
import {externalAccountMessages} from './ExternalAccountConfirmation';
import {SupportLink} from '../../support/SupportLink';

type Props = {
  identityVerificationEnabled?: boolean;
  onVerifyIdentity?: () => void;
  accountType?: OpenapiAccountTypeEnum;
};

export const FormExplanation = ({
  identityVerificationEnabled,
  onVerifyIdentity,
  accountType,
}: Props) => {
  const intl = useIntl();
  return (
    <view.p css={{font: 'body.small'}}>
      {identityVerificationEnabled
        ? intl.formatMessage(
            externalAccountMessages.externalAccountIdentityVerification,
            {
              Link: (text: string) => (
                <Link key="link" onPress={onVerifyIdentity}>
                  {text}
                </Link>
              ),
            },
          )
        : intl.formatMessage(
            externalAccountMessages.externalAccountFieldClarification,
            {
              Link: (text: string) => (
                <SupportLink key="supportLink" accountType={accountType}>
                  {text}
                </SupportLink>
              ),
            },
          )}
    </view.p>
  );
};
